import type { ComponentType } from 'react';
import React, { Component } from 'react';
import { withRouter } from 'next/router';
import type { Router } from 'next/router';
import logger from 'Logger/logger';
import { isStrictlyProductionEnv } from 'Utils/context/contextUtils';
type State = {
  hasError: boolean;
};
type WithRouter<Props> = Props & {
  router: Router;
};

const HocErrorBoundary = function <Props>(
  ChildComponent: ComponentType<Props>,
): ComponentType<Props> {
  class ErrorBoundary extends Component<WithRouter<Props>, State> {
    constructor(props) {
      super(props);
      this.state = {
        hasError: false,
      };
    }

    static getDerivedStateFromError() {
      return {
        hasError: true,
      };
    }

    // eslint-disable-next-line class-methods-use-this
    componentDidCatch(err, info) {
      logger.error({
        err,
        info,
      });
    }

    render() {
      const { router, ...props } = this.props;

      if (this.state.hasError) {
        if (isStrictlyProductionEnv()) {
          const { locale } = router.query;
          router.replace({
            pathname: '/500',
            query: Boolean(locale) && {
              locale,
            },
          });
          this.setState({
            hasError: false,
          });
        }

        return null;
      }

      return <ChildComponent {...props} />;
    }
  }

  return withRouter(ErrorBoundary);
};

export default HocErrorBoundary;
